import useEstateDetailDataStore from '~/stores/useEstateDetailDataStore'
import type { EstateDetailInterface } from '~/types/api/EstateDetail'

export function useEstateDetailDataSetter(
  estateData: EstateDetailInterface | null
) {
  const estateDetailDataStore = useEstateDetailDataStore()

  onBeforeMount(() => {
    estateDetailDataStore.setData(estateData)
  })

  onBeforeUnmount(() => {
    if (estateDetailDataStore.data?.id !== estateData?.id) return

    estateDetailDataStore.clearData()
  })
}
